import React from 'react';
import styled from 'styled-components';
import { PillTab, PillTabProps } from './PillTab';

const PillTabBarContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.8rem;
  align-items: center;
  padding: 1.6rem 0;
  width: fit-content;
`;

export interface PillTabBarProps {
  tabs: Omit<PillTabProps, 'selected' | 'onClick'>[];
  selectedTabId?: string;
  onTabChange: (tabId: string) => void;
  className?: string;
}

export const PillTabBar: React.FC<PillTabBarProps> = ({ tabs, selectedTabId, onTabChange, className }) => {
  return (
    <PillTabBarContainer className={className}>
      {tabs.map(tab => (
        <PillTab key={tab.id} {...tab} selected={tab.id === selectedTabId} onClick={onTabChange} />
      ))}
    </PillTabBarContainer>
  );
};
